import { FC } from 'react';
import classNames from 'classnames';

import { specialcharacters } from '@rikstv/play-common/src/utils/special-characters/special-characters.utils';

import styles from './Arch.module.css';
interface Props {
  background: 'light' | 'dark';
}

export const ArchRight: FC<Props> = ({ background }) => {
  const containerClass = classNames(styles.archright, styles[background]);
  return <div className={containerClass}>{specialcharacters.nbsp}</div>;
};
